module.exports = require("tsyringe");